const LogoSchema = (url = '', logo = '') =>
  JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'Organization',
    url,
    logo,
  });

export default LogoSchema;
